import type { IGradeTarget } from "@/@types/campaign-grade";
import { GradeTargetReason } from "@/@types/campaign-grade";

export const GRADE_BLOCK_MESSAGES: Record<GradeTargetReason, string> = {
  [GradeTargetReason.COLOR_NEVER_SOLD]:
    "Este produto nunca foi vendido nesta cor. Confira o código antes de salvar.",
  [GradeTargetReason.SIZE_NEVER_SOLD]:
    "Este produto nunca foi vendido neste tamanho. Confira o código antes de salvar.",
  [GradeTargetReason.COMBINATION_NEVER_SOLD]:
    "Este produto vende nesta cor e neste tamanho, mas nunca nesta combinação. Confirma mesmo assim?",
  [GradeTargetReason.ITEM_NEVER_SOLD]:
    "Este produto ainda não tem venda registrada, então não é possível conferir a grade. Confirma mesmo assim?",
};

export const ALL_COLORS_LABEL = "Todas as cores";
export const ALL_SIZES_LABEL = "Todos os tamanhos";
export const NO_GRADE_SELECTED = "Escolha ao menos uma cor ou um tamanho.";
export const SAME_TARGET_ADDED =
  "Esta grade já foi adicionada para este produto.";
export const BOTH_AXES_WILDCARD =
  "Marcar as duas opções equivale ao produto completo, que já é o padrão da campanha.";

export const PENDING_TARGET_TITLE = "Grade não adicionada";
export const PENDING_TARGET_DESCRIPTION = (target: string): string =>
  `Você escolheu ${target} e não clicou em "Adicionar grade". O que fazer antes de salvar?`;
export const NOTHING_TO_SAVE = "Nenhuma alteração para salvar.";
export const VALIDATION_UNAVAILABLE =
  "Não foi possível conferir a grade agora. Tente de novo em instantes.";
export const TARGETS_LOAD_FAILED =
  "Não foi possível carregar as grades deste produto.";

export const gradeTargetLabel = (grade: IGradeTarget): string => {
  const color: string = grade.color ? `Cor ${grade.color}` : ALL_COLORS_LABEL;
  const size: string = grade.size ? `Tamanho ${grade.size}` : ALL_SIZES_LABEL;
  return `${color} · ${size}`;
};

export const gradeCountLabel = (grades: IGradeTarget[] | undefined): string => {
  const total: number = grades?.length ?? 0;
  return total === 1 ? "1 grade" : `${total} grades`;
};

export const GRADE_RESTRICTION_LABEL = "Restringir por cor/tamanho";
export const ITEM_GRADES_TITLE = "Grade dos produtos";
export const GRADE_RESTRICTION_HINT_ON =
  "Cada produto precisa de ao menos uma grade: cor e tamanho, só a cor ou só o tamanho.";
export const GRADE_RESTRICTION_HINT_OFF =
  "A campanha vale para o produto inteiro, em qualquer cor e tamanho.";
export const GRADE_BUTTON_LABEL = "Grade";
export const GRADE_BUTTON_TITLE =
  "Restringir esta campanha a cores e tamanhos específicos deste produto";
export const GRADE_BUTTON_ARIA = (itemCode: string): string => `Grade do produto ${itemCode}`;
export const ITEMS_WITHOUT_GRADE_TITLE = (count: number): string =>
  `${count} produto(s) sem grade`;
export const ITEMS_WITHOUT_GRADE_DESCRIPTION =
  "Com a restrição por cor/tamanho ligada, defina a grade destes produtos para continuar:";
export const MANAGE_ITEMS_GRADE_REQUIRED =
  "Esta campanha é restrita por cor/tamanho: inclua produtos pela tela Produtos, que pede a grade de cada SKU.";
export const ITEMS_WITHOUT_GRADE_TO_ENABLE =
  "Para ligar a restrição por cor/tamanho, defina a grade destes produtos na coluna Grade e tente de novo:";
export const MORE_ITEMS_LABEL = (count: number): string => `+${count}`;
export const GRADE_REQUIRED_TO_SAVE =
  "Com a restrição por cor/tamanho ligada, o produto precisa de ao menos uma grade.";
export const GRADE_SAVED = (itemCode: string): string =>
  `Grades do produto ${itemCode} atualizadas.`;
export const GRADE_CLEARED = (itemCode: string): string =>
  `Produto ${itemCode} voltou a valer para todas as grades.`;
export const GRADE_SAVE_FAILED = "Não foi possível salvar as grades deste produto.";
export const RESTRICTION_ENABLED = "Restrição por cor/tamanho ligada.";
export const RESTRICTION_DISABLED =
  "Restrição por cor/tamanho desligada: os produtos voltam a valer inteiros.";
export const RESTRICTION_ON_SHORT = "Ligada";
export const RESTRICTION_OFF_SHORT = "Desligada";
